export default __webpack_public_path__ + "static/media/livenyte_icon.a872113a.png";